import Logo from "@/components/Logo";
import React from "react";

export default function ErrorPage({
  title = "Ocorreu um erro ao carregar o checkout.",
  description = "Tente novamente mais tarde.",
  errorCode = "",
}) {
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center text-center px-5">
      <Logo />
      <h1 className="mt-5 mb-2.5 text-3xl sm:text-4xl font-semibold">
        {title}
      </h1>
      {description.split("<br />").map((line, index) => (
        <p key={index} className="text-muted-foreground mt-5 text-lg">
          {line}
        </p>
      ))}
      {errorCode && (
        <p className="text-muted-foreground mt-5 text-lg">
          Código de erro: {errorCode}
        </p>
      )}
    </div>
  );
}
